"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _jquery = _interopRequireDefault(require("jquery"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FormBlock = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(FormBlock, _React$Component);
  function FormBlock() {
    var _this;
    _classCallCheck(this, FormBlock);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FormBlock, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      show: _this.props.show
    });
    _defineProperty(_assertThisInitialized(_this), "_focusOnFirstField", function () {
      (0, _jquery["default"])(_this.refs.body).find('input[type="text"],textarea').first().focus().select();
    });
    _defineProperty(_assertThisInitialized(_this), "_clicked", function (event) {
      event.preventDefault();
      if (_this.props.handleClick) {
        _this.props.handleClick(!_this.props.show, event);
      } else {
        _this.setState({
          show: !_this.state.show
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_isShow", function () {
      if (_this.props.handleClick) {
        return _this.props.show;
      }
      return _this.state.show;
    });
    _defineProperty(_assertThisInitialized(_this), "_renderHeader", function () {
      var arrowClassName = _this._isShow() ? 'glyphicon glyphicon-triangle-bottom' : 'glyphicon glyphicon-triangle-right';
      var headingClassName = (0, _classnames["default"])(['panel-heading', _style["default"].heading, _defineProperty({}, _style["default"].headingAlone, !_this._isShow())]);
      var header = /*#__PURE__*/_react["default"].createElement("div", {
        className: headingClassName,
        onClick: _this._clicked
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].arrowWrapper
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: arrowClassName
      })), _this.props.icon && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].icon
      }, _this.props.icon), /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].link
      }, _this.props.title), _this.props.comment, (_this.props.rightBlock || _this.props.isError) && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].rightBlock
      }, _this.props.isError && /*#__PURE__*/_react["default"].createElement("i", {
        className: 'glyphicon glyphicon-warning-sign ' + _style["default"].error
      }), _this.props.rightBlock));
      if (_this.props.connectDragSource) {
        header = _this.props.connectDragSource(header);
      }
      return header;
    });
    return _this;
  }
  _createClass(FormBlock, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.handleClick) {
        if (prevProps.show !== this.props.show && this.props.show) {
          this._focusOnFirstField();
        }
      } else if (prevState.show !== this.state.show && this.state.show) {
        this._focusOnFirstField();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var panelClassName = (0, _classnames["default"])(['panel', 'panel-' + this.props.type, _style["default"].panel]);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: panelClassName
      }, this._renderHeader(), this._isShow() && /*#__PURE__*/_react["default"].createElement("div", {
        className: "panel-body",
        ref: "body"
      }, this.props.children));
    }
  }]);
  return FormBlock;
}(_react["default"].Component);
_defineProperty(FormBlock, "propTypes", {
  title: _propTypes["default"].node,
  type: _propTypes["default"].string,
  comment: _propTypes["default"].node,
  icon: _propTypes["default"].node,
  show: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  handleClick: _propTypes["default"].func,
  rightBlock: _propTypes["default"].node,
  connectDragSource: _propTypes["default"].func,
  children: _propTypes["default"].node,
  isError: _propTypes["default"].bool
});
_defineProperty(FormBlock, "defaultProps", {
  // Title to show on the link
  title: 'Hidden block',
  // Type of the block
  // Options: 'default', 'primary', 'success', 'info', ' warning', 'danger'
  type: 'default',
  // Comment to show after the link
  comment: null,
  // Class for icon
  icon: null,
  // Show the hidden block or not?
  // If handleClick is null then it will be the default value.
  // If handleClick is a function then it will be the actual value.
  show: false,
  // Callback when clicking on the link
  handleClick: null,
  // Something to show on the right side
  rightBlock: null,
  // Is there some error inside the block
  isError: false
});